import { render, staticRenderFns } from "./FeedbackDataTable.vue?vue&type=template&id=b2b198d2"
import script from "./FeedbackDataTable.vue?vue&type=script&lang=js"
export * from "./FeedbackDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports